module.exports = __webpack_public_path__ + "img/haita.7aa8239e.png";